import { Pipe, PipeTransform } from '@angular/core';

import { pigeonRoutePartColor } from '../constants/constants';

@Pipe({ name: 'pigeonRoutePartColor' })
export class PigeonRoutePartColorPipe implements PipeTransform {
  transform(
    index: number,
    pigeonRouteDetails: any,
    parameter: string,
    pigeonStationTime: any,
    pigeonsServiceStartHour: number,
    pigeonsServiceParameterInfo: any,
    pigeonMos: any,
    dtgs: any,
    dtgIndex: any,
    pigeonsServiceEndHour: number,
    pigeonServiceDay: any,
    pigeonServiceMosData: any,
    param?: string
  ) {
    return pigeonRoutePartColor(
      index,
      pigeonRouteDetails,
      parameter,
      pigeonStationTime,
      pigeonsServiceStartHour,
      pigeonsServiceParameterInfo,
      pigeonMos,
      dtgs,
      dtgIndex,
      pigeonsServiceEndHour,
      pigeonServiceDay,
      pigeonServiceMosData,
      param
    );
  }
}
